import { useContext, useEffect, useState } from "react";
import ChatbotBtn from "../../assets/images/chatbot.svg";

import styles from "./index.module.scss";
import { UserContext } from "../../contexts/UserContext/UserContextProvider";
import { networkContext } from "../../contexts/NetworkContext/NetworkContextProvider";
import { ChatPage } from "./partials/Chat_Page";
import { ChatUserListSection } from "./partials/UserList_Page";
import {
  getLastChatUsers,
  getNotificationData,
  getUserActiveStatus,
  removeNotification,
} from "../../Managers/Chat";
// import UserManager from "../../Managers/Users";
import { slice, concat } from "lodash";
import { isMobileDevice } from "../../utils/getPlatformInfo";

const LIMIT = 5;

const ChatBot = ({ webinarDetails }) => {
  const {
    isChatBotOpen,
    setIsChatBotOpen,
    chatSectionStatus,
    toggleChatSection,
    user,
  } = useContext(UserContext);

  const {
    getRoomIdWithUser,
    roomId,
    updateRoomId,
    chatUser,
    setChatUser,
    openChat,
    networkingUserData,
  } = useContext(networkContext);

  const [onlineUsers, setOnlineUsers] = useState([]);

  const [userListLoad, setUserListLoad] = useState(true);

  const [allConnections, setAllConnections] = useState([]);

  const [connections, setConnections] = useState([]);

  const [listComplete, setListComplete] = useState(false);
  const [index, setIndex] = useState(LIMIT);
  const [showMoreCount, setShowMoreCount] = useState(1);
  const [showMoreStatus, setShowMoreStatus] = useState(false);

  const [notificationData, setNotificationData] = useState(null);

  const [notificationUser, setNotificationUser] = useState(null);

  const [userList, setUserList] = useState([]);

  const [height, setHeight] = useState(window.visualViewport?.height || window.innerHeight);

  useEffect(()=>{
    window.visualViewport.addEventListener("resize",()=>{
      const viewportHeight = window.visualViewport?.height || window.innerHeight;
      setHeight(viewportHeight);
    })
  },[])

  useEffect(() => {
    setUserList(networkingUserData);
    setUserListLoad(false);
  }, [networkingUserData]);

  const showMoreBtn = () => {
    const newIndex =
      index < allConnections.length ? index + LIMIT : allConnections.length + 1;

    const newShowMore = newIndex < allConnections.length - 1;
    const newList = concat(connections, slice(allConnections, index, newIndex));
    setIndex(newIndex);
    setConnections(newList);
    setListComplete(!newShowMore);
    // let updatedCount = showMoreCount + 1;
    // setShowMoreCount(updatedCount);

    // if (userList.length >= updatedCount * 4) {
    //   let newUpdatedList = allConnections.slice(
    //     (showMoreCount - 1) * 4,
    //     updatedCount * 4
    //   );
    //   setConnections([...newUpdatedList]);
    // } else {
    //   let newUpdatedList = allConnections.slice(
    //     (showMoreCount - 1) * 4,
    //     user.length
    //   );

    //   setConnections([...newUpdatedList]);
    //   setListComplete(true);
    // }
  };

  const showLess = () => {
    let newIndex = index - LIMIT;
    const newList = allConnections.slice(0, 4);
    setIndex(newIndex);
    setConnections(newList);
    setListComplete(false);
    document.getElementById("chatSectionDiv").scrollTo(0, 0);
  };

  const OnBackfromChat = (otherUserId) => {
    removeNotification(webinarDetails.id, user.uid, otherUserId);
    toggleChatSection(false);
  };

  useEffect(() => {
    if (webinarDetails && webinarDetails.id) {
      //set online user list
      getUserActiveStatus(webinarDetails.id, (data) => {
        setOnlineUsers(Object.keys(data));
        // console.log("online data 23421423eg vds", Object.keys(data));
      });
      //get all user list
      getData();

      //get user of last chat
      getLastChatUsers(webinarDetails.id, user.uid, async (data) => {
        if (data) {
          let arrofData = Object.values(data);

          arrofData.sort((a, b) =>
            a.createdAt < b.createdAt ? 1 : b.createdAt < a.createdAt ? -1 : 0
          );

          // let finalData = [];
          // let finalData = await Promise.all(
          //   arrofData.map((ans) => {
          //     return UserManager._get.getUser(ans.chatWith);
          //   })
          // );

          // console.log("final data", data);
          // console.log("DSdsdsdsdsdsdsdssdsdsdsdsdssdsdsdsdsdsdss", res);
          // arrofData.forEach((ans) => {
          //   UserManager._get.getUser(ans.chatWith).then((response) => {
          //     finalData.push(response);
          //   });
          // });
          // console.log("final data", finalData);
          // finalData.sort((a, b) =>
          //   a.createdAt < b.createdAt ? 1 : b.createdAt < a.createdAt ? -1 : 0
          // );
          // console.log("dagta", data);
          if (arrofData.length <= 4) {
            setShowMoreStatus(true);
          }
          if (arrofData.length > 4) {
            setShowMoreStatus(false);
          }
          if (arrofData.length > showMoreCount * 4) {
            setConnections(arrofData.slice(0, showMoreCount * 4));
          } else {
            setConnections(arrofData);
          }
          setAllConnections(arrofData);
        }

        // console.log("last chat user", finalData);
      });

      //get notification

      getNotificationData(webinarDetails.id, user.uid, (data) => {
        if (data) {
          setNotificationUser(Object.keys(data));
          setNotificationData(data);
        }
        // console.log("notification data", data);
      });
    }
  }, [webinarDetails, user]);

  const getData = async () => {
    // const data = networkingUserData;
  };

  // useEffect(() => {
  //   userList.forEach((x) => {
  //     if (onlineUsers.includes(x.id)) {
  //       x.statusMode = "online";
  //     }
  //   });
  // }, []);

  // console.log(getNetworkingData(webinarDetails.id));

  const handleClick = (sendUserData) => {
    openChat(webinarDetails.id, sendUserData);
    return;
    toggleChatSection(true);
    setChatUser(sendUserData);
    let generatedRoomId = getRoomIdWithUser(user.uid, sendUserData.userid);
    updateRoomId(generatedRoomId);
    removeNotification(webinarDetails.id, user.uid, sendUserData.userid);
  };

  return (
    <>
      {/* <div
        className={styles.chatBotContainer}
        onClick={() => setIsChatBotOpen(!isChatBotOpen)}
      >
        <img src={ChatbotBtn} alt="" />
      </div> */}

      {isChatBotOpen && (
        <div style={isMobileDevice?{height:`${height}px`}:{}} className={styles.chatContainer}>
          {chatSectionStatus ? (
            <ChatPage
              chatUser={chatUser}
              user={user}
              webinarDetails={webinarDetails}
              OnBackfromChat={OnBackfromChat}
            />
          ) : (
            <ChatUserListSection
              connections={connections}
              showMoreBtn={showMoreBtn}
              userList={userList}
              setChatUser={setChatUser}
              userListLoad={userListLoad}
              onlineUsers={onlineUsers}
              handleClick={handleClick}
              listComplete={listComplete}
              showLess={showLess}
              showMoreStatus={showMoreStatus}
              notificationData={notificationData}
              notificationUser={notificationUser}
            />
            // <>
            //   <ChatContainerHeader />
            //   <div className={styles.chatBotContainerDiv}>
            //     <ChatConnections
            //       userList={connections}
            //       showMoreBtn={showMoreBtn}
            //     />
            //     <UserListContainer
            //       userList={userList}
            //       toggleChatSection={toggleChatSection}
            //     />
            //   </div>
            // </>
          )}
        </div>
      )}
    </>
  );
};
export default ChatBot;
